import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';

export async function initializePushNotifications(userId) {
  // Only for native platforms
  if (!Capacitor.isNativePlatform()) {
    console.log('Not a native platform, skipping Capacitor push setup');
    return null;
  }

  try {
    console.log('Initializing Capacitor push notifications...');

    // Request permission
    let permStatus = await PushNotifications.checkPermissions();
    console.log('Current permission status:', permStatus);

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
      console.log('Permission request result:', permStatus);
    }

    if (permStatus.receive !== 'granted') {
      console.log('Push notification permission denied');
      return null;
    }

    // Register with FCM
    await PushNotifications.register();
    console.log('Registered for push notifications');

    // Listen for registration
    await PushNotifications.addListener('registration', async (token) => {
      console.log('✅ FCM Token received:', token.value);
      
      // Save token to Firestore
      if (userId) {
        try {
          await updateDoc(doc(db, 'users', userId), {
            fcmToken: token.value,
            fcmTokenUpdatedAt: new Date().toISOString(),
            platform: 'android'
          });
          console.log('✅ FCM token saved to Firestore');
        } catch (error) {
          console.error('Error saving FCM token:', error);
        }
      }
    });

    // Handle registration errors
    await PushNotifications.addListener('registrationError', (error) => {
      console.error('❌ Push registration error:', error);
    });

    // Handle push notifications received (foreground)
    await PushNotifications.addListener('pushNotificationReceived', (notification) => {
      console.log('📬 Push notification received:', notification);
      // Notification is automatically shown by Android
    });

    // Handle notification tap
    await PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
      console.log('👆 Push notification tapped:', notification);
      
      // Navigate based on notification data
      const data = notification.notification.data;
      if (data.type === 'mention' && data.chatId) {
        // You can use React Router or your navigation method here
        console.log('Navigate to chat:', data.chatId);
        // window.location.href = `/#/chat/${data.chatId}`;
      }
    });

    console.log('✅ Push notification listeners set up');
    return true;
  } catch (error) {
    console.error('❌ Error initializing push notifications:', error);
    return null;
  }
}

export function removePushListeners() {
  if (Capacitor.isNativePlatform()) {
    PushNotifications.removeAllListeners();
    console.log('Push notification listeners removed');
  }
}
